import {CustomQuery} from "./types"

export const getNotificationsForUser: CustomQuery = {
    queryKey: "subscribedActivitiesByUser",
    type: "LIST",
    query: /*GraphQL*/`
        query subscribedActivitiesByUser($userId: ID!) {
            subscribedActivitiesByUser(userId: $userId) {
                items {
                    id
                    read
                    userSubscription {
                        id
                        commentId
                        discussionId
                        userId
                        user {
                            id
                            distributorId
                            lastName
                            firstName
                            email
                            roles
                            enabled
                        }
                    }
                    activity {
                        id
                        message
                        url
                    }
                    createdAt
                    updatedAt
                    _version
                    _deleted
                    _lastChangedAt
                }
                nextToken
                startedAt
            }
        }
    `
}

export const markAsRead: CustomQuery = {
    queryKey: "updateSubscribedActivity",
    type: "UPDATE",
    query:  /* GraphQL */ `
        mutation UpdateSubscribedActivity(
            $input: UpdateSubscribedActivityInput!
            $condition: ModelSubscribedActivityConditionInput
        ) {
            updateSubscribedActivity(input: $input, condition: $condition) {
                id
                userId
                userSubscriptionId
                activityId
                read
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
            }
        }
    `
}

export const deleteMessage: CustomQuery = {
    queryKey: "deleteSubscribedActivity",
    type: "DELETE",
    query:  /* GraphQL */ `
        mutation DeleteSubscribedActivity(
            $input: DeleteSubscribedActivityInput!
            $condition: ModelSubscribedActivityConditionInput
        ) {
            deleteSubscribedActivity(input: $input, condition: $condition) {
                id
                userId
                userSubscriptionId
                activityId
                read
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
            }
        }
    `
}
